export var ToastContrast;
(function (ToastContrast) {
    ToastContrast["undefined"] = "undefined";
    ToastContrast["default"] = "default";
    ToastContrast["high"] = "high";
})(ToastContrast || (ToastContrast = {}));
export var ToastSize;
(function (ToastSize) {
    ToastSize["default"] = "default";
    ToastSize["mini"] = "mini";
})(ToastSize || (ToastSize = {}));
export var ToastType;
(function (ToastType) {
    ToastType["success"] = "success";
    ToastType["warning"] = "warning";
    ToastType["error"] = "error";
    ToastType["info"] = "info";
})(ToastType || (ToastType = {}));
//# sourceMappingURL=types.js.map
